import { createFileRoute } from "@tanstack/react-router";
import CoreWebVitalsPage from "@/pages/CoreWebVitalsPage";

export const Route = createFileRoute("/tools/core-web-vitals")({
  component: CoreWebVitalsPage,
});
